// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileMenuItem_container__S9FF7","icon":"MobileMenuItem_icon__DHruq","title":"MobileMenuItem_title__S6ip6","subtitle":"MobileMenuItem_subtitle__yc7AJ"};